<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

@if (label()) {
  <p-floatlabel [variant]="floatLabelVariant()">
    <p-select id="selectItems"
                [disabled]="disabled()"
                [readonly]="readonly()"
                [required]='required()'
                [options]="isFilter() ? (items() | addAllSelectItemOption: ('select-items.all' | translate)) : items()"
                [style]="style()"
                [scrollHeight]="scrollHeight()"
                [appendTo]="appendTo()"
                [baseZIndex]="1000"
                [ngClass]="{'ng-invalid': form.invalid, 'ng-valid': form.valid, 'ng-dirty': form.dirty }"
                (onClear)="onClear()"
                [ngModel]="selectedItem()"
                (ngModelChange)='selectedItem.set($event)'
                (onChange)="change($event)"
                optionLabel="defaultLabel" dataKey="uuid"
                [autoDisplayFirst]="isFilter()" [showClear]="isFilter() || showClear()" data-testid="select-items-select"></p-select>
    <label for="selectItems">{{label()}}</label>
  </p-floatlabel>
} @else {
  <p-select id="selectItems"
              [disabled]="disabled()"
              [readonly]="readonly()"
              [required]='required()'
              [options]="isFilter() ? (items() | addAllSelectItemOption: ('select-items.all' | translate)) : items()"
              [style]="style()"
              [scrollHeight]="scrollHeight()"
              [appendTo]="appendTo()"
              [baseZIndex]="1000"
              [ngClass]="{'ng-invalid': form.invalid, 'ng-valid': form.valid, 'ng-dirty': form.dirty }"
              (onClear)="onClear()"
              [ngModel]="selectedItem()"
              (ngModelChange)='selectedItem.set($event)'
              (onChange)="change($event)"
              optionLabel="defaultLabel" dataKey="uuid"
              [autoDisplayFirst]="isFilter()" [showClear]="isFilter() || showClear()" data-testid="select-items-select-2"></p-select>
}


